import styled from 'styled-components';

export const TagSelectWrap = styled.div`
  .ant-select-selection-search {
    > input {
      display: none !important;
    }
  }
`;
export const UserSelectView = styled.div`
  .margin-view {
    padding: 5px;
    &.add-text {
      cursor: pointer;
      color: #2684ff;
    }
  }
`;
